import { AlertTriangle, X } from 'lucide-react'

import { Button } from '@/components/ui/button'
import { useLegalBannerStore } from '@/stores/legal-banner-store'
import type { PendingDocument } from '@/types/legal'

interface LegalBannerProps {
  documents: PendingDocument[]
  daysRemaining: number | null
  onReviewClick: () => void
}

export function LegalBanner({ documents, daysRemaining, onReviewClick }: LegalBannerProps) {
  const { dismissBanner } = useLegalBannerStore()

  const documentNames = documents.map((doc) => doc.documentName).join(' e ')

  return (
    <div
      className='bg-amber-50 dark:bg-amber-950/50 border-b border-amber-200 dark:border-amber-800 px-4 py-3'
      role='alert'
      data-testid='legal-banner'
    >
      <div className='flex items-center justify-between gap-4 max-w-7xl mx-auto'>
        <div className='flex items-center gap-3'>
          <AlertTriangle className='h-5 w-5 text-amber-600 dark:text-amber-500 shrink-0' />
          <p className='text-sm text-amber-800 dark:text-amber-200'>
            {documents.length > 1 ? 'Nossos ' : 'Nosso '}
            <strong>{documentNames}</strong>
            {documents.length > 1 ? ' foram atualizados' : ' foi atualizado'}.
            {daysRemaining !== null && (
              <>
                {' '}
                Você tem{' '}
                <strong>
                  {daysRemaining} {daysRemaining === 1 ? 'dia' : 'dias'}
                </strong>{' '}
                para revisar e aceitar.
              </>
            )}
          </p>
        </div>

        <div className='flex items-center gap-2 shrink-0'>
          <Button
            variant='default'
            size='sm'
            onClick={onReviewClick}
            data-testid='legal-banner-review-button'
          >
            Revisar agora
          </Button>
          <Button
            variant='ghost'
            size='icon-sm'
            onClick={dismissBanner}
            aria-label='Fechar aviso'
            data-testid='legal-banner-close-button'
          >
            <X className='h-4 w-4' />
          </Button>
        </div>
      </div>
    </div>
  )
}
